import { render, staticRenderFns } from "./SetPass.vue?vue&type=template&id=2de57582&scoped=true"
import script from "./SetPass.vue?vue&type=script&lang=js"
export * from "./SetPass.vue?vue&type=script&lang=js"
import style0 from "./SetPass.vue?vue&type=style&index=0&id=2de57582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de57582",
  null
  
)

export default component.exports